<template>
  <div class="site_homePage_title" style="margin-top: 10px">
    <div style="margin-top: 0px">
      <el-button v-if="playShow === true" @click="pauseTimer" type="text" icon="el-icon-video-pause" style="font-size: 25px"></el-button>
      <el-button v-if="playShow === false" @click="startTimer" type="text" icon="el-icon-video-play" style="font-size: 25px"></el-button>
    </div>
    <div style="width: 45%;height: 70%; display: flex;flex-direction: row;align-items: center;justify-content: space-between">
      <div style="background-color: #0a84ff;height: 100%;width: 58%" class="site_homePage_title_inner">
        <div class="varchar_size" style="color: whitesmoke;font-weight: bold">{{'CW制造部' + ' ' + '组立物件概况'}}</div>
      </div>

      <div class="site_homePage_title_inner varchar_size" style="width: 40%;height: 100%">{{this.wujian_short_name}}</div>
    </div>
    <div class="site_homePage_title_inner">
      <div class="varchar_size">{{this.currentTime}}</div>
    </div>
    <div>
      <el-button @click="nextPage(this.showPage)" type="text" icon="el-icon-arrow-right-bold" style="font-size: 25px"></el-button>
    </div>
  </div>
  <div v-if="showPage === 'ZL'" style="width: 100%;height: 100%">
    <ZLSiteWJHomePage :parentData ="this.wujian_id"></ZLSiteWJHomePage>
  </div>
  <div v-show="showPage === 'Visualization'" style="width: 100%;height: 100%">
    <MfgZLVisualization :parentData ="this.wujian_id"></MfgZLVisualization>
  </div>
</template>

<script>

import ZLSiteWJHomePage from "@/views/applications/bus/homePage/ZLSiteWJHomePage";
import MfgZLVisualization from "@/views/applications/bus/homePage/MfgZLVisualization";
import {useDateFormat} from "@vueuse/core";

export default {
  name: "MfgZLHomePage",
  components:{
    ZLSiteWJHomePage,MfgZLVisualization
  },
  data(){
    return{
      playShow:true,
      timer: null,
      timerVisualization: null,
      timerZL: null,
      wujian_id:'',
      wujian_short_name:'',
      currentTime: '',
      showPage:'ZL',
    }
  },
  methods: {
    nextPage(value){
      if ("ZL" === value){
        this.showPage = 'Visualization'
      }
      if ("Visualization" === value){
        this.showPage = 'ZL'
      }
      this.pauseTimer()
    },
    //开始轮播
    startTimer(){
      let showPage = this.showPage
      this.playShow = true
      this.timerVisualization = setInterval(() => {
        this.showPage = showPage
        this.timerZL = setTimeout(() =>{
          if ("ZL" === showPage){
            this.showPage = 'Visualization'
          }
          if ("Visualization" === showPage){
            this.showPage = 'ZL'
          }
        },30000)
      },60000)

    },
    // 暂停轮播
    pauseTimer(){
      this.playShow = false
      clearInterval(this.timerVisualization)
      clearInterval(this.timerZL)
    },
    async getWuJianShortName() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianData',this.wujian_id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.wujian_short_name = res.data.wujian_short_name
      this.wujianInfoData = res.data
    },
    dateFormat(){
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
  },
  mounted(){
    this.timer = setInterval(()=>{
      this.dateFormat();
    }, 1000)
    this.timerVisualization = setInterval(() => {
      this.showPage = "Visualization"
      this.timerZL = setTimeout(() =>{
        this.showPage = "ZL"
      },30000)
    },60000)
  },
  created() {
    this.wujian_id = this.$route.params.key
    this.getWuJianShortName()
    //清除缓存
    // sessionStorage.removeItem('wujianVisualization');
    // sessionStorage.removeItem('facadeList');
  }
}
</script>

<style scoped>

</style>